import React from "react";
import "./StatusBadge.scss";

const StatusBadge = ({ status, label }) => {
  const statusColors = {
    Success: "badge badge-success",
    Completed: "badge badge-primary",
    Pending: "badge badge-warning",
    Blocked: "badge badge-danger",
  };

  const className = statusColors[status] || "badge badge-secondary";
  return <span className={className}>{label ?? status}</span>;
};

export default StatusBadge;
